/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StatisticKeyEnum = {
    type: 'Enum',
} as const;
